import * as Yup from 'yup';
export const signUpSchema = Yup.object().shape({
  fullName: Yup.string().required('نام و نام خانوادگی اجباری می باشد'),
  email: Yup.string().email('نشانی ایمیل را صحیح وارد کنید'),
  province: Yup.string().required('استان اجباری می باشد'),
  city: Yup.string().required(' شهراجباری می باشد'),
  account_type: Yup.string().required('نقش کاربری نباید خالی باشد.'),
});
